import { Container, Box, Grid, GridItem, Link } from '@terminal/design-system';
import Card from './Card/Card';

import sharecardImage from '../../public/images/resources/sharecard.jpg';

import { primaryCategory } from '../../helpers/categoryFilters';

export default function RelatedPosts({
  title,
  posts,
  filteredOutId,
}: {
  title: string;
  posts: {
    id: string;
    title: string;
    featuredImage: {
      node: {
        sourceUrl: string;
        altText: string;
      };
    };
    target: string;
    path: string;
    resourceType: string;
  }[];
  filteredOutId: string;
}) {
  const filteredLatestPosts = () => {
    const filtered = posts.filter((post) => {
      return post.id !== filteredOutId;
    });
    if (filtered.length > 3) {
      return filtered.slice(0, 3);
    }
    return filtered;
  };

  return (
    filteredLatestPosts().length >= 1 && (
      <Box
        p={{ base: '3.2rem 0 4rem', lg: '4rem 0 5rem' }}
        borderTop="0.0625rem solid #E4E4E4"
        bgColor="#F6F9FA"
      >
        <Container>
          <Box
            color="#6A7B8D"
            fontWeight="700"
            mb={{ base: '2rem', lg: '2.5rem' }}
            maxW={{
              base: '18.4375rem',
              sm: '26.875rem',
              lg: '56.25rem',
            }}
            ml={{ base: 'auto', lg: '0' }}
            mr={{ base: 'auto' }}
          >
            {title}
          </Box>
          <Grid
            templateColumns={{
              base: '1fr',
              lg: '1fr 1fr 1fr',
            }}
            gap={{ base: '1.5rem', lg: '2.5rem', xl: '4.0625rem' }}
          >
            {filteredLatestPosts().map((post) => {
              const postImage = post.featuredImage
                ? post.featuredImage.node.sourceUrl
                : sharecardImage.src;

              const postAltText = post.featuredImage ? post.featuredImage.node.altText : '';
              return (
                <GridItem key={post.id}>
                  <Link
                    href={post.path}
                    display="block"
                    maxW={{
                      base: '18.4375rem',
                      sm: '26.875rem',
                    }}
                    ml="auto"
                    mr="auto"
                    role="group"
                    _hover={{ textDecoration: 'none' }}
                    target={post.target}
                    aria-label={`Read ${post.title}`}
                  >
                    <Card
                      categoryTitle={`${primaryCategory(post)} | ${post.resourceType}`}
                      imageUrl={postImage}
                      altText={postAltText}
                      cardTitle={post.title}
                      size="medium"
                    />
                  </Link>
                </GridItem>
              );
            })}
          </Grid>
        </Container>
      </Box>
    )
  );
}
